import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Negara = () => {
    const columns = [
        {
            name: 'Kode Negara',
            cell: row => row['kodeNegara'] 
        },
        {
            name: 'Uraian',
            cell: row => row['uraianNegara'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listNegara, setlistNegara] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistNegara = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listNegara(null, page, size)
            setlistNegara(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistNegara([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistNegara(0, 10)
    }, [getlistNegara])

    const handleChangePage = (page) => {
        getlistNegara(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listNegara(null, page - 1, size)
        setlistNegara(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Negara</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listNegara}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default Negara